'use client'

import { useEffect } from 'react'

const ACCOUNT_STATE_EVENT = 'ql7:account-state'
const BLOCKED_DESTINATION = 'https://www.google.com/'

function applyGlobalBlockState(state) {
  if (state?.globalBlock?.active !== true) return false
  try { window.location.replace(BLOCKED_DESTINATION) } catch {}
  return true
}

export default function ServiceGlobalBlockBridge() {
  useEffect(() => {
    const onAccountState = (event) => { applyGlobalBlockState(event?.detail) }
    window.addEventListener(ACCOUNT_STATE_EVENT, onAccountState)
    applyGlobalBlockState(window.__QL7_ACCOUNT_STATE__)
    return () => window.removeEventListener(ACCOUNT_STATE_EVENT, onAccountState)
  }, [])
  return null
}
